import React from "react";
import wulala from '../../assets/games/wu.png'
import "./index.css";
const Page = () => {
  const itemRender = (item) => (
    <div className="content" key={item.name_en}>
      <img alt="游戏" src={item.img} />
      <div className="name-zh">{item.name_zh}</div>
      <div className="desc">
        <div className="desc_label">{item.desc}</div>
        <div className="tags">
          {item.tags.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </div>
    </div>
  );

  const list = [
    {
      img: wulala,
      name_en: "IDLE ADVENTURERS",
      name_zh: "不休的乌拉拉Lite",
      desc: "一款轻松愉快的放置挂机 RPG 游戏。玩家可以自由选择各具特色的英雄职业，搭配个性化的宠物组合，挑战怪物和强大的BOSS。每一次战斗胜利，都会为带来丰富的材料，帮助英雄孵化和培养全新宠物。轻松放置，尽享养成乐趣，宠物冒险之旅由此开始。",
      tags: ["放置", "挂机", "RPG"],
    },
  ];

  return (
    <div className="games-container">
      <div className="games-header">游戏</div>
      <div className="content-wrap">{list.map((item) => itemRender(item))}</div>
    </div>
  );
}

export default Page;
